// eslint-disable-next-line no-restricted-imports
import { Link as BemloLink, LinkProps } from '../ui'

import { forceTrailingSlash } from '../utils/path'

export const Link = ({ to, ...props }: LinkProps) => (
  <BemloLink to={forceTrailingSlash(to)} {...props} />
)
